import axios from 'axios';

const API = axios.create({ baseURL: '/api' });

// Admin-in seçdiyi filial. Yalnız məsləhətdir — server admin olmayan
// istifadəçi üçün bu başlığı nəzərə almır və onu öz filialına bağlayır.
export const BRANCH_KEY = 'ems_branch';
export function getBranch() {
  try { return localStorage.getItem(BRANCH_KEY) || 'all'; } catch { return 'all'; }
}
export function setBranch(v) {
  try { localStorage.setItem(BRANCH_KEY, v || 'all'); } catch {}
}

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  const b = getBranch();
  if (b && b !== 'all') cfg.headers['X-Branch-Id'] = b;
  return cfg;
});

API.interceptors.response.use(
  r => r,
  err => {
    const url = err.config?.url || '';
    // Giriş cəhdinin özü də 401 qaytarır (yanlış şifrə). Onu "sessiya bitdi"
    // kimi qəbul edib səhifəni yeniləsək, xəta mesajı yazılan kimi silinir —
    // istifadəçi nə baş verdiyini oxuya bilmir.
    const isLoginAttempt = url.includes('/auth/login');

    if (err.response?.status === 401 && !isLoginAttempt) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setBranch('all');   // növbəti giriş bütün kampuslarla başlasın
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;
